import { CommonModule, DatePipe } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TuiTable } from '@taiga-ui/addon-table';
import { TuiButton, TuiHint } from '@taiga-ui/core';
import { TuiPdfViewerOptions, TuiPdfViewerService } from '@taiga-ui/kit';
import { DocumentService } from '../../services/document.service';
import { PrescriptionForm } from '../../models/prescriptionForm/prescriptionForm';
import { PrescriptionFormService } from '../../services/prescription-form.service';
import { PolymorpheusContent } from '@taiga-ui/polymorpheus';
import { PpcInformationsComplementaires } from '../../models/prescriptionForm/ppcInformationsComplementaires';
import { TuiTagModule } from '@taiga-ui/legacy';
import { DepInformationsComplementaires } from '../../models/prescriptionForm/depInformationsComplementaires';

@Component({
  selector: 'app-prescription-form-row',
  standalone: true,
  imports: [TuiTable, DatePipe, CommonModule, TuiHint, TuiButton, TuiTagModule],
  templateUrl: './prescription-form-row.component.html',
  styleUrl: './prescription-form-row.component.scss',
})
export class PrescriptionFormRowComponent {
  @Input() prescriptionForm: PrescriptionForm | undefined;

  readonly prescritpionFormService = inject(PrescriptionFormService);
  readonly documentService = inject(DocumentService);
  private readonly sanitizer = inject(DomSanitizer);
  private readonly pdfService = inject(TuiPdfViewerService);

  protected show(
    actions: PolymorpheusContent<TuiPdfViewerOptions>,
    id: number,
  ): void {
    this.prescritpionFormService.pdf(id).subscribe({
      next: (blob) => {
        // Créer une URL sécurisée
        const url: SafeResourceUrl =
          this.sanitizer.bypassSecurityTrustResourceUrl(
            URL.createObjectURL(blob),
          );

        // Passer cette URL au `pdfService`
        this.pdfService
          .open(url, {
            label: 'Prescription',
            actions,
          })
          .subscribe();
      },
      error: (err) => {
        console.error('Erreur lors du chargement du PDF :', err);
      },
    });
  }

  protected showRecapitulatif(
    actions: PolymorpheusContent<TuiPdfViewerOptions>,
    id: number,
  ): void {
    this.prescritpionFormService.recapitulatif(id).subscribe({
      next: (blob) => {
        // Créer une URL sécurisée
        const url: SafeResourceUrl =
          this.sanitizer.bypassSecurityTrustResourceUrl(
            URL.createObjectURL(blob),
          );

        // Passer cette URL au `pdfService`
        this.pdfService
          .open(url, {
            label: 'Récapitulatif',
            actions,
          })
          .subscribe();
      },
      error: (err) => {
        console.error('Erreur lors du chargement du PDF :', err);
      },
    });
  }

  protected hasRecapitulatif(): boolean {
    if (
      this.prescriptionForm &&
      this.prescriptionForm.pdf &&
      this.prescriptionForm.id &&
      this.prescriptionForm.informationsComplementaires instanceof
        PpcInformationsComplementaires &&
      this.prescriptionForm.informationsComplementaires.recapitulatif != null
    ) {
      return true;
    } else {
      return false;
    }
  }

  protected isInitiale(): boolean {
    return (
      ((this.prescriptionForm &&
        this.prescriptionForm.informationsComplementaires instanceof
          PpcInformationsComplementaires &&
        this.prescriptionForm.informationsComplementaires.ppcTypeSlug ==
          'dap_initial') ||
        (this.prescriptionForm &&
          this.prescriptionForm.informationsComplementaires instanceof
            DepInformationsComplementaires &&
          this.prescriptionForm.informationsComplementaires.depTypeSlug ==
            '3mois')) ??
      false
    );
  }
}
